var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopic3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.03 112.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient-10);}.cls-2{fill:url(#radial-gradient-9);}.cls-3{fill:#161617;}.cls-4{fill:url(#radial-gradient-5);}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:url(#radial-gradient-3);}.cls-7{fill:url(#radial-gradient-11);}.cls-8{fill:#161a1a;}.cls-9{fill:url(#radial-gradient-8);}.cls-10{fill:url(#radial-gradient-2);}.cls-11{fill:url(#radial-gradient-4);}.cls-12{fill:url(#radial-gradient-6);}.cls-13{fill:#daedef;}.cls-14{fill:url(#radial-gradient-7);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 42.52,
    cy: 77.12,
    fx: 42.52,
    fy: 77.12,
    r: 45.58,
    gradientTransform: "translate(0 125.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#75c3c6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 42.47,
    cy: 72.36,
    fx: 42.47,
    fy: 72.36,
    r: 7.58,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 42.49,
    cy: 64.19,
    fx: 42.49,
    fy: 64.19,
    r: 25.57,
    gradientTransform: "translate(0 125.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75c3c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 42.48,
    cy: 61.48,
    fx: 42.48,
    fy: 61.48,
    r: 25.56,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 42.48,
    cy: 58.8,
    fx: 42.48,
    fy: 58.8,
    r: 25.55,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 6.96,
    cy: 72.36,
    fx: 6.96,
    fy: 72.36,
    r: 1.25,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 10.35,
    cy: 72.36,
    fx: 10.35,
    fy: 72.36,
    r: 1.25,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 13.73,
    cy: 72.36,
    fx: 13.73,
    fy: 72.36,
    r: 1.25,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 71.15,
    cy: 72.36,
    fx: 71.15,
    fy: 72.36,
    r: 1.25,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 74.53,
    cy: 72.36,
    fx: 74.53,
    fy: 72.36,
    r: 1.25,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 77.92,
    cy: 72.36,
    fx: 77.92,
    fy: 72.36,
    r: 1.25,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.22,109.73v-8.79h1.76l3.55,6.39h-.3v-6.39h1.65v8.79h-1.76l-3.55-6.39h.3v6.39h-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.5,109.85c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45s.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.4-.34s-.42-.1-.73-.1c-.22,0-.47.02-.74.06s-.53.1-.78.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.94-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.26.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.59,109.73v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59.27-.13.58-.2.92-.2s.65.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.06-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.11.03-.22.09-.33.16s-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.16,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09-.21-.49-.32-1.13-.32-1.9s.11-1.43.32-1.93c.21-.5.52-.87.93-1.1.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM29.16,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6s.11-.72.11-1.27-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.66,112.34v-9.12h1.46l.12.71h.08c.13-.24.31-.44.54-.59.23-.15.52-.22.86-.22.4,0,.77.11,1.11.32.34.22.62.56.83,1.04s.32,1.1.32,1.88-.11,1.4-.34,1.92c-.23.52-.59.9-1.07,1.17s-1.09.39-1.84.39c-.06,0-.11,0-.17,0-.06,0-.11,0-.17-.02v2.52h-1.73ZM34.86,108.51c.44,0,.77-.14,1-.43.23-.28.34-.8.34-1.56,0-.53-.04-.94-.13-1.21-.09-.28-.21-.47-.37-.57-.16-.1-.34-.15-.55-.15-.15,0-.29.03-.43.09-.14.06-.25.16-.34.27v3.52c.07,0,.15.02.24.03.09,0,.17.02.23.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.72,109.73v-9.6h1.73v3.79h.08c.17-.25.38-.45.64-.59s.56-.21.92-.21c.32,0,.61.07.87.22.26.14.47.38.63.72.16.33.24.78.24,1.35v4.31h-1.73v-4.17c0-.34-.06-.57-.2-.7s-.3-.19-.52-.19c-.1,0-.21.02-.33.05-.12.03-.23.08-.33.15s-.2.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.28,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09s-.32-1.13-.32-1.9.11-1.43.32-1.93.52-.87.93-1.1c.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM47.28,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6.07-.29.11-.72.11-1.27s-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.04,104.59v-1.37h4.16v1.37h-4.16ZM53.19,109.84c-.7,0-1.25-.18-1.63-.55-.39-.37-.58-.98-.58-1.83v-4.23l.32-2.29h1.41v6.32c0,.42.07.7.21.86s.38.24.72.24c.09,0,.18,0,.28-.01.1,0,.2-.02.32-.04v1.42c-.14.04-.31.07-.49.09s-.37.04-.55.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.24,109.85c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09s-.32-1.13-.32-1.9.11-1.43.32-1.93.52-.87.93-1.1c.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM57.24,108.55c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6.07-.29.11-.72.11-1.27s-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.73,109.73v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59s.58-.2.92-.2.66.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.07-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.12.03-.22.09-.33.16-.1.07-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.71,102.27c-.37,0-.64-.09-.82-.26-.18-.17-.27-.41-.27-.71s.09-.55.27-.72c.18-.17.45-.26.82-.26s.65.09.82.26c.18.17.26.41.26.72s-.09.54-.26.71c-.18.17-.45.26-.82.26ZM66.84,109.73v-6.5h1.74v6.5h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.23,109.85c-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.6-.98-1.09-.22-.5-.33-1.14-.33-1.93s.12-1.45.38-1.95c.25-.49.61-.85,1.07-1.08.46-.22,1.01-.34,1.65-.34.2,0,.4,0,.59.03.19.02.38.05.56.09v1.42c-.14-.03-.28-.05-.43-.07-.15-.01-.28-.02-.4-.02-.37,0-.68.06-.92.18-.24.12-.41.31-.53.59s-.17.64-.17,1.11c0,.5.05.89.16,1.17.11.28.27.48.48.6.21.12.48.17.8.17.15,0,.31-.02.47-.05.16-.03.34-.08.53-.14v1.43c-.22.08-.45.13-.69.17-.24.04-.47.05-.7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.75,109.85c-.3,0-.59-.02-.87-.07-.28-.04-.55-.11-.81-.2v-1.38c.26.08.53.15.8.2s.56.07.85.07c.35,0,.61-.06.76-.18.15-.12.23-.28.23-.48,0-.17-.04-.3-.13-.39s-.21-.15-.39-.2l-.83-.2c-.49-.12-.86-.33-1.11-.64-.25-.3-.38-.71-.38-1.22,0-.61.22-1.11.67-1.48.45-.37,1.1-.56,1.97-.56.27,0,.52.01.76.04.24.03.46.07.66.12v1.38c-.22-.05-.43-.1-.64-.12-.21-.03-.44-.04-.69-.04-.29,0-.52.03-.69.09-.17.06-.29.15-.36.25-.07.1-.11.21-.11.32,0,.16.04.27.13.36.08.08.21.15.38.2l.83.21c.5.12.87.33,1.12.62.25.29.37.7.37,1.22,0,.65-.23,1.15-.68,1.52s-1.07.56-1.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.47,24.2h0c-.37-.63-.89-1.15-1.52-1.51L44.61.57c-.64-.36-1.36-.56-2.09-.57h0c-.73,0-1.44.2-2.08.57L2.12,22.69c-.64.37-1.18.9-1.55,1.53C.2,24.86,0,25.58,0,26.32v44.27c0,.74.2,1.47.57,2.12h.06c.36.62.87,1.14,1.49,1.51l38.32,22.11c.65.36,1.38.56,2.12.57h0c.72,0,1.42-.2,2.04-.55l38.33-22.12c.64-.37,1.16-.9,1.53-1.53.36-.63.55-1.35.57-2.08V26.32c0-.74-.2-1.47-.57-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M38.98,61.37c-4.62-1.03-8.56-4.01-10.79-8.18,2.23-4.15,6.16-7.13,10.76-8.15-4.52,1.91-6.62,7.13-4.71,11.64.9,2.12,2.59,3.81,4.71,4.71l.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M56.76,53.2c-2.24,4.16-6.18,7.15-10.79,8.18,4.52-1.91,6.62-7.13,4.71-11.64-.9-2.12-2.59-3.81-4.71-4.71,4.62,1.02,8.56,4.01,10.79,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M42.47,41.43c-8.08,0-15.51,4.44-19.33,11.56l-.11.21.11.22c5.74,10.68,19.05,14.67,29.73,8.93,3.79-2.04,6.89-5.14,8.93-8.93l.11-.22-.11-.21c-3.82-7.12-11.25-11.57-19.33-11.56ZM42.47,64.07c-7.15,0-13.81-3.63-17.68-9.65-.48-.74-.48-1.7,0-2.44,6.29-9.76,19.31-12.58,29.07-6.29,2.52,1.62,4.66,3.77,6.29,6.29.48.74.48,1.7,0,2.44-3.87,6.01-10.53,9.64-17.68,9.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M78.42,50.09c0,.25-.2.45-.45.45h-8.3c-.2-.31-.42-.63-.63-.91-2.74-3.76-6.24-6.9-10.28-9.2h0c-.4-.23-.79-.45-1.2-.63-1.13-.58-2.29-1.09-3.47-1.54-.43-.16-.86-.32-1.3-.47-1.28-.42-2.58-.76-3.89-1.03-.48-.1-.98-.18-1.48-.26-1.64-.24-3.29-.36-4.94-.36-1.64,0-3.28.12-4.91.36-.5.08-.99.16-1.48.26-1.31.24-2.61.57-3.89.97-.44.14-.87.3-1.3.46-1.19.45-2.35.96-3.48,1.54h0c-.4.21-.81.42-1.19.63-4.06,2.32-7.57,5.48-10.31,9.26-.23.3-.44.63-.63.91H6.98c-.25,0-.46-.2-.46-.45,0-.25.21-.46.46-.46h6.65c.71,0,1.38-.33,1.81-.89,2.99-4,6.83-7.29,11.25-9.62.41-.22.82-.42,1.26-.63,1.19-.57,2.41-1.07,3.65-1.49.45-.16.89-.3,1.35-.43,1.38-.41,2.78-.72,4.2-.94.52-.09,1.03-.16,1.55-.21,1.25-.14,2.51-.21,3.77-.21,1.28,0,2.56.07,3.83.21.52.06,1.04.13,1.55.21,1.42.23,2.83.55,4.21.96.45.13.9.27,1.34.43,1.25.42,2.47.92,3.66,1.5.42.19.82.4,1.26.63,4.4,2.33,8.23,5.61,11.21,9.6.43.57,1.1.9,1.81.89h6.6c.25,0,.46.19.47.45,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M71.03,52.75h-3.02c-.79,0-1.53-.41-1.94-1.09-7.99-13.03-25.04-17.1-38.06-9.11-3.71,2.28-6.83,5.4-9.11,9.11-.42.68-1.16,1.1-1.96,1.09H6.98c-.25,0-.46.2-.46.45h0c0,.25.21.46.46.46h9.96c.78,0,1.51.39,1.93,1.06,7.98,13.04,25.01,17.14,38.05,9.16,3.73-2.29,6.87-5.42,9.16-9.16.41-.67,1.14-1.09,1.93-1.08h9.94c.25,0,.45-.21.45-.46h0c0-.25-.2-.45-.45-.45h-6.92v.03ZM42.47,67.07c-9.75.01-18.74-5.29-23.44-13.84,7.1-12.95,23.35-17.68,36.3-10.58,4.46,2.45,8.13,6.12,10.58,10.58-4.7,8.54-13.69,13.85-23.44,13.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M69.66,55.86c-.21.31-.42.63-.63.91-10.67,14.66-31.21,17.9-45.87,7.23-2.77-2.02-5.21-4.46-7.23-7.23-.22-.3-.43-.63-.63-.91H6.98c-.25,0-.46.21-.46.46h0c0,.25.21.45.46.45h6.65c.71,0,1.38.33,1.81.89,11.17,14.93,32.32,17.98,47.25,6.81,2.58-1.93,4.88-4.23,6.81-6.81.43-.57,1.1-.9,1.81-.89h6.64c.25,0,.45-.2.45-.45h0c0-.25-.2-.46-.45-.46h-8.3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M42.73,29.78l-.21-.11-.22.11c-1.89,1.02-3.63,2.31-5.14,3.84-.36.36-.7.72-1.04,1.11.49-.09.99-.18,1.48-.26.35-.36.72-.72,1.11-1.06s.86-.74,1.32-1.09c1.48-1.11,3.51-1.11,4.98,0,.46.35.9.7,1.33,1.09s.75.69,1.11,1.06c.5.08.99.16,1.48.26-.33-.38-.68-.76-1.04-1.11-1.52-1.53-3.26-2.82-5.16-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M44.81,26.01c-1.18-.77-1.89-2.09-1.89-3.5v-9.35h-.9v9.36c0,1.41-.71,2.72-1.89,3.48-3.5,2.31-6.43,5.38-8.57,8.98-.23.4-.47.81-.67,1.21.43-.17.86-.32,1.3-.46.23-.4.47-.8.72-1.18,1.88-2.91,4.31-5.42,7.16-7.4,1.45-1.01,3.37-1.01,4.82,0,2.85,1.98,5.29,4.5,7.17,7.42.26.39.5.78.72,1.18.44.14.87.3,1.3.46-.21-.41-.44-.82-.68-1.21-2.14-3.62-5.08-6.7-8.59-9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M38.91,22.56c.3-.22.63-.43.91-.63v-8.77h-.91v6.17c-.02,1.29-.62,2.51-1.64,3.31-4.77,3.78-8.43,8.78-10.59,14.47-.16.43-.31.86-.46,1.3.39-.23.79-.45,1.19-.63h0c.16-.42.33-.84.5-1.26,2.31-5.57,6.12-10.4,10.99-13.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M58.29,37.11c-2.16-5.69-5.82-10.69-10.59-14.47-1.03-.8-1.63-2.03-1.64-3.33v-6.16h-.91v8.78c.31.2.63.42.91.63,4.88,3.54,8.69,8.36,11.01,13.92.18.42.34.84.49,1.26.41.2.81.42,1.2.63-.14-.38-.31-.81-.47-1.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 42.47,
    cy: 53.2,
    r: 7.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.86,60.38c-2.57,6.5-10.41,9.69-16.91,7.13-2.84-1.12-5.17-3.23-6.58-5.93-.09-.22-.19-.43-.31-.63-.32-.64-.7-1.25-1.13-1.82-.38-.51-.8-.98-1.26-1.43-5.13-5.12-13.43-5.12-18.55,0-.9.9-1.67,1.93-2.27,3.05-.12.27-.25.53-.4.8v.03c-3.33,6.14-11,8.43-17.14,5.1-1.24-.67-2.36-1.54-3.31-2.58-1.01-1.09-2.3-2.34-2.87-3.71h0c.54,1.36,1.3,2.62,2.26,3.73,4.7,5.49,12.96,6.13,18.45,1.43.72-.61,1.36-1.3,1.93-2.06.4-.53.76-1.08,1.08-1.66h0c.13-.25.26-.5.37-.75v-.03c3.31-6.17,11-8.48,17.16-5.16,2.24,1.2,4.06,3.05,5.23,5.3.12.22.23.45.33.68.32.62.69,1.2,1.11,1.75,4.32,5.81,12.54,7.01,18.35,2.69,2.02-1.5,3.57-3.56,4.45-5.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M77.83,63.12c-1.93,4.81-7.05,7.93-12.24,7.95-4.71,0-9.04-2.62-11.23-6.79-.09-.22-.19-.43-.31-.63-.32-.64-.7-1.24-1.13-1.81-.38-.51-.8-.98-1.26-1.43-5.13-5.12-13.43-5.12-18.55,0-.43.42-.82.87-1.18,1.35-.41.53-.78,1.1-1.09,1.7-.12.27-.25.53-.4.8h0c-3.32,6.14-10.99,8.43-17.13,5.11-1.24-.67-2.37-1.55-3.32-2.59-1.01-1.09-2.3-2.35-2.87-3.73h0c.54,1.36,1.3,2.62,2.26,3.73,4.7,5.49,12.96,6.13,18.45,1.43.72-.61,1.36-1.3,1.93-2.06.4-.53.76-1.08,1.08-1.66h0c.13-.25.26-.5.37-.75h0c3.32-6.17,11.01-8.47,17.18-5.15,2.23,1.2,4.05,3.04,5.22,5.28.12.22.23.45.33.68.32.62.69,1.2,1.11,1.75,4.33,5.81,12.54,7.01,18.35,2.68,2-1.49,3.54-3.53,4.42-5.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.83,65.84c-2.57,6.5-10.38,9.64-16.88,7.07-2.84-1.12-5.17-3.23-6.58-5.93-.09-.22-.19-.43-.31-.63-.32-.64-.7-1.24-1.13-1.81-.38-.51-.8-.98-1.26-1.43-5.13-5.12-13.43-5.12-18.55,0-.42.42-.82.87-1.18,1.35-.41.53-.78,1.1-1.09,1.7-.12.27-.25.54-.4.8v.03c-3.33,6.15-11.01,8.43-17.15,5.1-2.56-1.39-5.06-3.62-6.17-6.31h0c1.98,5,6.81,8.28,12.19,8.3,4.11,0,7.98-1.93,10.45-5.21.4-.52.76-1.08,1.08-1.66h0c.13-.25.26-.5.37-.75h0c.59-1.09,1.33-2.09,2.21-2.97,4.95-4.94,12.98-4.94,17.92.02.9.91,1.67,1.94,2.26,3.08.12.22.23.45.33.69.32.61.69,1.2,1.11,1.75,4.32,5.81,12.53,7.01,18.34,2.69,2.01-1.5,3.55-3.53,4.43-5.88h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 6.96,
    cy: 53.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 10.35,
    cy: 53.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 13.73,
    cy: 53.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 71.15,
    cy: 53.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74.53,
    cy: 53.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 77.92,
    cy: 53.2,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.51,93.34c-.72,0-1.43-.19-2.06-.55L5.11,72.39c-.58-.33-1.07-.8-1.43-1.36h0l-.08-.1c-.36-.63-.55-1.34-.55-2.06V28.04c0-.72.19-1.43.55-2.05.37-.61.89-1.11,1.51-1.47L40.42,4.11c.62-.36,1.31-.55,2.03-.55h0c.72,0,1.42.2,2.04.55l35.35,20.42c.58.34,1.07.81,1.42,1.38h0l.07.1c.35.63.54,1.34.55,2.06v40.82c0,.71-.2,1.41-.55,2.03-.36.62-.88,1.13-1.5,1.49l-35.31,20.38c-.58.33-1.22.52-1.89.54h-.12,0ZM3.95,70.62l.07.08c.33.52.78.96,1.32,1.26l35.33,20.43c.54.3,1.14.46,1.75.48h.09c.62,0,1.23-.17,1.77-.48l35.33-20.4c.55-.32,1.01-.78,1.33-1.33.31-.55.48-1.17.49-1.8V28.04c0-.62-.16-1.22-.45-1.77l-.05-.08c-.32-.54-.78-.99-1.32-1.31L44.29,4.5c-.55-.31-1.18-.48-1.81-.49h0c-.63,0-1.25.17-1.8.49L5.34,24.89c-.55.32-1.02.78-1.35,1.33-.32.55-.49,1.18-.49,1.82v40.81c0,.61.16,1.22.45,1.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic3);
export default __webpack_public_path__ + "static/media/topic_3.8c03748abc6659c16dd2b19875017ca9.svg";
export { ForwardRef as ReactComponent };